<template>
    <div class="app-home">
        <template v-if="!isRegAndLogin">
            <home-header
                @on-click="goBack" :title="deviceName" :comeBack="Module_HomeComeBack">
            </home-header>
            <pull-refresh @refresh="refresh" :disabled="true">            
                <div class="home-container">
                    <div class="home-package" v-if="Module_MyFlow">
                        <div class="home-package-bg"></div>
                        <div class="home-package-header">
                            <span class="title">{{ $t('home.my_flow') }}</span>
                            <!-- <button class="manage-package" @click="goToMyFlow">
                                <i class="fas fa-gear"></i>
                                {{ ('管理套餐') }}
                            </button> -->
                            <div class="manage-package" @click="goToMyFlow" >{{ $t('home.more') }} </div>
                        </div>
                        <div class="home-package-con" v-if="packageUseDetail">
                            <h3 class="package-name van-multi-ellipsis--l2 mt10">{{ packageUseDetail.goodsName }}</h3>
                            <p v-if="!packageUseDetail.extendValVos || !packageUseDetail.a_getValue_hideFlowSize || packageUseDetail.a_getValue_hideFlowSize && packageUseDetail.a_getValue_hideFlowSize != '1' " class="mt10">{{packageUseDetail.a_surplusFlow.type == 'DISC' ? $t('order.remainingHighFlow') : $t("order.remainingFlow")}}: {{packageUseDetail.a_surplusFlow.remainFlow | filterFlow}}</p>
                            <p class="mt10" v-if="packageUseDetail.status !== 'NOT_ACTIVATED' && packageUseDetail.isUseActive">{{packageUseDetail.a_activeTime.name}}: {{packageUseDetail.a_activeTime.time}}</p>
                            <span class="state-tips">{{ packageUseDetail.status !== 'NOT_ACTIVATED' && packageUseDetail.isUseActive ? $t('home.package_useing') : $t('home.unused') }}</span>
                        </div>
                        <div class="home-package-no-con" v-else>
                            <span v-if="isShowNoData">{{ $t('home.no_data_available') }}</span>
                        </div>
                    </div>
                    <div class="my-nav-bar" :class="{
                        'grid-columns': (Module_ChargeCode + Module_Coupons_Page) === 1
                    }" v-if="Module_ChargeCode || Module_Coupons_Page">

                        <div class="line" v-if="isShowNavLine"/>
                        <!-- <div class="item" @click="goToMyFlow" v-if="Module_MyFlow">
                            <img src="../../assets/imgs/home/my_flow@3x.png" />
                            <div class="name">{{ $t('home.my_flow') }}</div>
                        </div> -->
                        <div class="item" @click="goToCharge" v-if="Module_ChargeCode">
                            <img src="../../assets/imgs/home/charge-icon.png" />
                            <div class="name">{{ $t('home.charge_code') }}</div>
                        </div>
                        <div class="item module-coupons" @click="goToCoupon" v-if="Module_Coupons_Page">
                            <div class="coupons-img-count">
                                <img src="../../assets/imgs/home/coupon.png" />
                                <span v-if="couponCount" class="coupons-count">{{couponCount}}</span>
                            </div>
                            <div class="name">{{ $t('home.coupons') }}</div>
                        </div>
                    </div>
                    <!-- <div v-if="local_package_list.length" class="list-box local-package">
                        <div class="title">
                            <span class="name">{{ $t('home.local_package') }}</span>
                            <span class="more MorePadding" @click="toMoreLocalPackage">{{ $t('home.more') }}</span>
                        </div>
                        <div class="local-package-list mt20">
                            <flexbox>
                                <template v-for="row in local_package_list">
                                    <flexbox-item @on-item-click="itemClickHandler(row)" :key="row.goodsCode" :bg="row.item_bg">    
                                        <img class="sign-icon" v-show="row.saleIconShow" :src="row.saleImageUrl" :style="row.iconStyle">
                                        <div v-show="row.multiRegionFlag" class="package-name van-multi-ellipsis--l3 f14">{{ row.goodsName }}</div>                                
                                        <div v-show="row.unlimitedFlag">                                    
                                            <div class="package-name van-multi-ellipsis--l3 f14">{{ row.goodsName }}</div>
                                            !-- <div class="unlimited-desc van-hairline--surround">{{ row.goodsName_H5_tag }} {{ row.high_speed_text }}</div>    --
                                        </div>
                                        <div v-show="row.normalFlag">                                    
                                            <div class="package-name van-multi-ellipsis--l3 f16">{{ row.goodsName }}</div>
                                            !-- <div class="package-period van-hairline--surround">{{ row.period }}</div> --
                                        </div>     
                                        <div v-if="row.promotionActivityCode && row.actTags && row.actTags[row.promotionActivityCode]">
                                            <span class="ext-attr" style="max-weight: 90%">{{row.actTags[row.promotionActivityCode]}}</span>
                                        </div>  
                                        <div class="ext-attr-con" v-else-if="row.attrValueList && row.attrValueList.length">
                                            <span class="ext-attr" v-for="(attrValue,index) in row.attrValueList" :key="index">{{attrValue}}</span>
                                        </div>
                                        <div class="package-price-box">
                                            <div class="price">{{ row.goodsPriceText }}</div>
                                            <span class="list-price" v-show="row.listPriceShow">{{ row.listPrice }}</span>
                                        </div>
                                    </flexbox-item>
                                </template>                                                
                            </flexbox>
                        </div>
                    </div> -->
                    
                    <!-- 新版套餐列表 -->
                    <div class="package-list-box" v-if="isShowPackageListBox">
                        <div class="package-list-header">
                            <van-tabs class="van-tabs-con" :active="activeTab" @change="packageTabsChange" swipeable animated color="#4361ee" title-active-color="#4361ee" title-inactive-color="#6a7282" line-width="50%" line-height="0.2em">
                                <van-tab v-for="tag in allTagList" :key="tag.tagKey" :name="tag.tagKey" :title="tag.tagName"></van-tab>
                                <template v-if="allTagList.length === 1 || !allTagList.length">
                                    <van-tab v-if="!allTagList.length" :title="$t('home.local_package')" name="LOCAL"></van-tab>
                                    <van-tab name="country2" disabled :title="('')"></van-tab>
                                </template>
                            </van-tabs>
                            <hr class="package-line"/>
                        </div>
                        <!-- <div class="continent-tab" v-show="activeTab === 'ROAMING'">
                            <span class="continent-item" :class="activeContinent === item.key ? 'active' : ''" @click="handlerContinent(item)" v-for="item in continentList" :key="item.key">{{item.value}}</span>
                        </div> -->
                        <div class="package-list" v-if="activeTab === 'LOCAL'">
                            <div class="package-list-left" v-if="isShowPackageListLeft" ref="packageListLeft">
                                <van-sidebar v-model="packageActiveKey">
                                    <template v-for="(tag,index) in packageGroupList">
                                        <van-sidebar-item @click="packageListGroupChange" :title="tag.tagValueName" :key="index" class="package-item-tag" :data-index="index" v-if="tag.packageList && tag.packageList.length"/>
                                    </template>
                                </van-sidebar>
                            </div>
                            <div class="package-list-right" ref="packageListRight" @scroll="packageListRightScroll('packageActiveKey')" :class="isPackageRightScroll ? 'package-list-right-scroll' : 'package-list-right-no-scroll'">
                                <div class="package-item-group" v-for="(group, index) in packageGroupList" :key="index" :data-index="index">
                                    <template v-if="group.packageList && group.packageList.length">
                                        <h2 class="group-title f14">{{ group.tagValueName }}</h2>
                                        <div class="package-item" :class="row.saleLeftTipShow ? 'pt15' : '' " v-for="(row) in group.packageList" :key="row.goodsCode" @click="itemClickHandler(row)">
                                            <span class="package-left-tips" v-show="row.saleLeftTipShow">{{ row.saleLeftTipText }}</span>
                                            <img class="sign-icon" v-show="row.saleIconShow" :src="row.saleImageUrl" :style="row.iconStyle">
                                            <h3 class="package-name van-multi-ellipsis--l3 f14">{{ row.goodsName }}</h3>
                                            <div class="package-ext-arrt">
                                                <div v-if="row.promotionActivityCode && row.actTags && row.actTags[row.promotionActivityCode]">
                                                    <span class="ext-attr" style="max-weight: 90%">{{row.actTags[row.promotionActivityCode]}}</span>
                                                </div>  
                                                <div class="ext-attr-con" v-else-if="row.attrValueList && row.attrValueList.length">
                                                    <span class="ext-attr" v-for="(attrValue,index) in row.attrValueList" :key="index">{{attrValue}}</span>
                                                </div>
                                            </div>

                                            <div class="package-price-box" v-if="!Module_CountDownAndSave">
                                                <div class="price">{{ row.goodsPriceText }}</div>
                                                <span class="list-price" v-show="row.listPriceShow">{{ row.listPrice }}</span>
                                            </div>
                                            <div class="price-countDown-box" v-if="Module_CountDownAndSave">
                                                <div class="package-price-discount">
                                                    <div class="price">{{ row.goodsPriceText }}</div>
                                                    <van-count-down @finish="handlerCountDownEnd(row)" :time="row.countDown" format="HH:mm:ss" v-if="row.showCountDown && Module_CountDownAndSave">
                                                        <template #default="timeData">
                                                            <div class="count-down-tips" v-if="row.showCountDown && Module_CountDownAndSave">
                                                                <span>{{$t('home.expires_in')}} </span>
                                                                <!-- {{timeData.days}} -->
                                                                <span class="block">{{ (timeData.hours + ((timeData.days || 0) * 24)) | filterCountDown }}</span>
                                                                <span class="colon">:</span>
                                                                <span class="block">{{ timeData.minutes | filterCountDown }}</span>
                                                                <span class="colon">:</span>
                                                                <span class="block">{{ timeData.seconds | filterCountDown }}</span>
                                                            </div>
                                                        </template>
                                                    </van-count-down>
                                                </div>
                                                <div class="package-countDown">
                                                    <span class="list-price" v-show="row.listPriceShow">{{ row.listPrice }}</span>
                                                    <div class="instant-savings" v-if="row.savingPrice && Module_CountDownAndSave">{{ $t('home.instant_savings') }} {{row.savingPrice}}</div>
                                                </div>
                                            </div>
                                            <!-- <div class="instant-savings" v-if="row.savingPrice && Module_CountDownAndSave||true">{{ $t('home.instant_savings') }} {{row.savingPrice}}</div> -->
                                            <!-- <div class="discount—con" >
                                                <div class="instant-savings" v-if="row.savingPrice && Module_CountDownAndSave">{{ $t('home.instant_savings') }} {{row.savingPrice}}</div>
                                                <van-count-down @finish="handlerCountDownEnd(row)" :time="row.countDown" format="HH:mm:ss" v-if="row.showCountDown && Module_CountDownAndSave">
                                                    <template #default="timeData">
                                                        <div class="count-down-tips" v-if="row.showCountDown && Module_CountDownAndSave">
                                                            <span>{{$t('home.expires_in')}} </span>
                                                            <span class="block">{{ (timeData.hours + ((timeData.days || 0) * 24)) | filterCountDown }}</span>
                                                            <span class="colon">:</span>
                                                            <span class="block">{{ timeData.minutes | filterCountDown }}</span>
                                                            <span class="colon">:</span>
                                                            <span class="block">{{ timeData.seconds | filterCountDown }}</span>
                                                        </div>
                                                    </template>
                                                </van-count-down>
                                            </div> -->
                                            <button class="package-buy-btn">{{ $t('home.buy_now') }}</button>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="package-list" v-if="activeTab === 'ROAMING'">
                            <div class="package-list-left" ref="packageListLeft" v-if="continentPackageList && continentPackageList.length">
                                <van-sidebar v-model="countryActiveKey">
                                    <template v-for="(country,index) in continentPackageList">
                                        <van-sidebar-item @click="packageListGroupChange" :title="country.name" :key="index" class="package-item-tag" :data-index="index" v-if="country.packageList && country.packageList.length"/>
                                    </template>
                                </van-sidebar>
                            </div>
                            <div class="package-list-right" ref="packageListRight" @scroll="packageListRightScroll('countryActiveKey')" :class="isPackageRightScroll ? 'package-list-right-scroll' : 'package-list-right-no-scroll'">
                                <div class="package-item-group" v-for="(group, index) in continentPackageList" :key="index" :data-index="index">
                                    <template v-if="group.packageList && group.packageList.length">
                                        <h2 class="group-title f14">{{ group.name }}</h2>
                                        <div class="package-item" :class="row.saleLeftTipShow ? 'pt15' : '' " v-for="(row) in group.packageList" :key="row.goodsCode" @click="itemClickHandler(row)">
                                            <span class="package-left-tips" v-show="row.saleLeftTipShow">{{ row.saleLeftTipText }}</span>
                                            <img class="sign-icon" v-show="row.saleIconShow" :src="row.saleImageUrl" :style="row.iconStyle">
                                            <h3 class="package-name van-multi-ellipsis--l3 f14">{{ row.goodsName }}</h3>
                                            <div class="package-ext-arrt">
                                                <div v-if="row.promotionActivityCode && row.actTags && row.actTags[row.promotionActivityCode]">
                                                    <span class="ext-attr" style="max-weight: 90%">{{row.actTags[row.promotionActivityCode]}}</span>
                                                </div>  
                                                <div class="ext-attr-con" v-else-if="row.attrValueList && row.attrValueList.length">
                                                    <span class="ext-attr" v-for="(attrValue,index) in row.attrValueList" :key="index">{{attrValue}}</span>
                                                </div>
                                            </div>

                                            <div class="package-price-box" v-if="!Module_CountDownAndSave">
                                                <div class="price">{{ row.goodsPriceText }}</div>
                                                <span class="list-price" v-show="row.listPriceShow">{{ row.listPrice }}</span>
                                            </div>
                                            <div class="price-countDown-box" v-if="Module_CountDownAndSave">
                                                <div class="package-price-discount">
                                                    <div class="price">{{ row.goodsPriceText }}</div>
                                                    <van-count-down @finish="handlerCountDownEnd(row)" :time="row.countDown" format="HH:mm:ss" v-if="row.showCountDown && Module_CountDownAndSave">
                                                        <template #default="timeData">
                                                            <div class="count-down-tips" v-if="row.showCountDown && Module_CountDownAndSave">
                                                                <span>{{$t('home.expires_in')}} </span>
                                                                <!-- {{timeData.days}} -->
                                                                <span class="block">{{ (timeData.hours + ((timeData.days || 0) * 24)) | filterCountDown }}</span>
                                                                <span class="colon">:</span>
                                                                <span class="block">{{ timeData.minutes | filterCountDown }}</span>
                                                                <span class="colon">:</span>
                                                                <span class="block">{{ timeData.seconds | filterCountDown }}</span>
                                                            </div>
                                                        </template>
                                                    </van-count-down>
                                                </div>
                                                <div class="package-countDown">
                                                    <span class="list-price" v-show="row.listPriceShow">{{ row.listPrice }}</span>
                                                    <div class="instant-savings" v-if="row.savingPrice && Module_CountDownAndSave">{{ $t('home.instant_savings') }} {{row.savingPrice}}</div>
                                                </div>
                                            </div>
                                            <!-- <div class="instant-savings" v-if="row.savingPrice && Module_CountDownAndSave">{{ $t('home.instant_savings') }} {{row.savingPrice}}</div> -->
                                            <!-- <div class="discount—con" >
                                                <div class="instant-savings" v-if="row.savingPrice && Module_CountDownAndSave">{{ $t('home.instant_savings') }} {{row.savingPrice}}</div>
                                                <van-count-down @finish="handlerCountDownEnd(row)" :time="row.countDown" format="HH:mm:ss" v-if="row.showCountDown && Module_CountDownAndSave">
                                                    <template #default="timeData">
                                                        <div class="count-down-tips" v-if="row.showCountDown && Module_CountDownAndSave">
                                                            <span>{{$t('home.expires_in')}} </span>
                                                            <span class="block">{{ (timeData.hours + ((timeData.days || 0) * 24)) | filterCountDown }}</span>
                                                            <span class="colon">:</span>
                                                            <span class="block">{{ timeData.minutes | filterCountDown }}</span>
                                                            <span class="colon">:</span>
                                                            <span class="block">{{ timeData.seconds | filterCountDown }}</span>
                                                        </div>
                                                    </template>
                                                </van-count-down>
                                            </div> -->
                                            <button class="package-buy-btn">{{ $t('home.buy_now') }}</button>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="countryList.length" class="list-box popular-destination">
                        <div class="title">
                            <span class="name">{{ $t('home.popular_destination') }}</span>
                        </div>
                        <div class="popular-destination-list mt20">
                            <ul>
                                <li v-for="item in countryList" :key="item.iso2" @click="goCountryPackageList(item)">
                                    <img :src="item.icon" />
                                    <div class="name van-ellipsis">{{ item.countryName }}</div>
                                </li>
                                <li @click="moreCountry" v-show="MoreConfigCountry">
                                    <img src="../../assets/imgs/home/more-icon.png" />
                                    <div class="name">{{ $t('home.more') }}</div>
                                </li>                        
                            </ul>
                        </div>
                    </div>
                </div>
            </pull-refresh>
        </template>
        <template v-if="isRegAndLogin">
            <new-home ref="NewHome" :fData="this"></new-home>
        </template>
        <!-- 手机物理按键事件处理 -->
        <physical-key @back-event-handler="goBack"></physical-key>        
    </div>
</template>

<script>
    //import { keepTwodecimalFull, keepTwodecimalFixed, isAndroid, isEmptyObject } from '../../utils/util'
    import { keepTwodecimalFixed, isAndroid } from '../../utils/util'
    import HomeHeader from './components/Header'
    import Flexbox from '../packages/components/flexbox/flexbox'
    import FlexboxItem from '../packages/components/flexbox/flexboxItem'
    import normal_bg from '../../assets/imgs/normal@3x.png'
    import unlimited_bg from '../../assets/imgs/unlimited@3x.png'
    import UserLogin from '@/lib/UserLogin';
    import checkProjectConfig from '@/lib/checkProjectConfig';
    import QueryRateList from '@/lib/QueryRateList';
    import AppAndtips from '@/data/appAndtips.js'
    import { Dialog, Tab, Tabs, Sidebar, SidebarItem, CountDown } from 'vant';
    import { throttle }  from '@/utils/util';
    import NewHome from './components/NewHome.vue';

    import dsBridgeUtil from '../../utils/dsBridgeUtil'
    import cookie from '../../utils/cookie'

    const DEFAULT_HOT_COUNTRY = ['JP', 'CN', 'US', 'SG', 'TH', 'GB', 'IT'];

    export default {
        name: 'AppHome',
        components: {
            HomeHeader,
            Flexbox,
            FlexboxItem,
            vanTabs: Tabs,
            vanTab: Tab,
            vanSidebar: Sidebar,
            vanSidebarItem: SidebarItem,
            NewHome,
            vanCountDown:CountDown,
        },
        props:{
            loginStatus: String 
        },
        data() {
            return {
                local_package_list: [],
                has_promotion_list: [],
                no_promotion_list: [],
                countryName: '', // 当前用户所在国家名称, 会根据placeCode获取
                countryList: [],                
                countryInfoList: [],
                MoreConfigCountry:false,
                deviceName:"",
                couponList: [], // 优惠券数据
                couponsTips:'', 
                packageTips:'', 
                packageActiveKey:0, // 套餐列表的key
                packageTagList: [], // 套餐标签列表
                packageGroupList: [], // 套餐分组列表
                isShowPackageList: false, // 是否显示套餐列表
                packageUseDetail: null,// 当前使用的套餐
                isPackageRightScroll: false, // 套餐列表右侧是否滚动
                allTagList:[], // 所有标签列表
                activeTab: 'LOCAL', // 当前激活的标签
                continentList:[], // 热门大洲列表
                continentPackageList: [], // 热门大洲套餐列表
                activeContinent:'', // 当前选中的大洲
                countryActiveKey: 0, // 当前选中的国家key
                isShowNoData: false, // 
            }
        },
        async created(){
            if(this.loginStatus == "loadFail"){
                this.$router.push({
                    name: 'LoadFail',
                    query:{"translateErrorMsg":'IMEI_Not_Exist'}
                });
            }
        },
        computed: {
            Module_MyFlow:function(){
                return checkProjectConfig.setAppThat(this).checkValue("Module_MyFlow",true);
            },
            Module_ChargeCode:function(){
                return checkProjectConfig.setAppThat(this).checkValue("Module_ChargeCode",true);
            },
            Module_Coupons_Page:function(){
                return checkProjectConfig.setAppThat(this).checkValue("Module_Coupons_Page",false);
            },
            Module_HomeComeBack:function(){
                return checkProjectConfig.setAppThat(this).checkValue("Module_HomeComeBack",true);
            },
            couponCount() {
                return this.couponList.length
            },
            isShowNavLine() {
                return (this.Module_ChargeCode + this.Module_Coupons_Page) >= 2;
            },
            isShowPackageListLeft() {
                return this.packageTagList && this.packageTagList.length && !(this.packageGroupList?.length === 1 && !this.packageGroupList[0].tagValueName)
            },
            isShowPackageListBox() {
                return (this.packageGroupList && this.packageGroupList.length && this.isShowPackageList) || (this.continentPackageList && this.continentPackageList.length);
            },
            isRegAndLogin() {
                let isRegAndLogin = JSON.parse(localStorage.getItem('isRegAndLogin') || 'false');
                return isRegAndLogin;
            },
            Module_CountDownAndSave() {
                return checkProjectConfig.setAppThat(this).checkValue("Module_CountDownAndSave",false);
            },
        },
        async mounted() {
            let that =this;
            that.urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
            that.deviceName = that.urlData.deviceName||that.urlData.imei
            // await this.gotoLoginFn();
            this.setup();
            this.MoreConfigCountry = await this.MoreConfigCountry_fn();

            // 监听页面滚动事件，处理套餐列表右侧滚动
            this.$nextTick(() => {
                window.addEventListener('scroll', this.eleScrollHandler);
            });

            // this.$http.post({
            //         url: '/bss/app/terminal/HandleDeviceBinding',
            //         data: {
            //             operateType: 1,
            //             customerId: this.urlData?.loginCustomerId,
            //             imei: '157950340000271',
            //             forceFlag: true
            //         }
            //     }).then(res => {
            //         console.log(res);
                    
            //     }).catch(err => {                    
            //         this.$toast(err);
            //     });
        },
        beforeDestroy() {
                window.removeEventListener('scroll', this.eleScrollHandler);
        },
        filters: {
            filterFlow(da) {
            if (da == 0) return "0MB";
            if (!da) return "";
            let flow = keepTwodecimalFixed(da < 1000 ? da : da / 1024);
            let langType = cookie.getCookie('langType')
            // 部分欧洲国家小数点采取 ， 形式
            let country = ['es-ES','pt-PT','de-DE','fr-FR']; 
            let showFlow = flow.toString().replace(/\.00$|0$/, "")
            if(country.includes(langType)){
                showFlow = showFlow.replace('.',',')
            }
            return `${showFlow}${(da < 1000 && "MB") || "GB"}`;
            },
            filterCountDown(da) {
                if (!da) return "00";
                return da < 10 ? `0${da}` : da;
            }
        },
        watch: {
            activeContinent(newVal) {
                if(!newVal) return;

                if(['UN29','UN50','UN52','UN57','UN60'].includes(newVal)){
                    this.getContinentPackageList({[newVal]: '1'});
                } else {
                    // 查询区域套餐
                    this.continentPackageList = this.packageTagList.map(item => {
                        return {
                            name:item,
                            packageList:[],
                        }
                    });

                    this.allTagList.forEach(item => {
                        if(item.tagKey === 'LOCAL'){
                            item.tagValueList.forEach(tag => {
                                this.getRegionPackageList({...(tag.extendValueMap || {}) , [newVal]: '1'},tag.tagValueName)
                            })
                        }
                    });
                }
            },
        },
        methods: {
            async gotoLoginFn(){
                let that =this;
                let isLoginByLoginPage = JSON.parse(sessionStorage.getItem('isLoginByLoginPage') || 'false');
                if(this.loginStatus == "gotoLogin"){
                    if(isLoginByLoginPage){
                        sessionStorage.setItem('urlData','{}');
                    }
                    return await UserLogin.setAppThat(that).gotoLogin();
                }else{
                    let access_token = cookie.getCookie('access_token');
                    if(access_token){
                        return true;    
                    }else{
                        if(isLoginByLoginPage){
                            sessionStorage.setItem('urlData','{}');
                        }
                        return await UserLogin.setAppThat(that).gotoLogin();
                    }
                }
            },
            async MoreConfigCountry_fn(){
                //判断是否有配置 
                let that = this;

                if(checkProjectConfig.setAppThat(that).status()){
                     //>并且8个国家费率国家                    
                    if(checkProjectConfig.setAppThat(that).checkValue("Module_RegionPager",true)){
                       let RateListNum =await QueryRateList.setAppThat(that).ReturnCountryNumber();
                       return RateListNum >= 8 ? true : false;
                    }
                }
                return checkProjectConfig.setAppThat(that).checkValue("Module_moreCountry",true);
            },
            setup() {
                return new Promise( async(resolve) => {
                    let placeCode = JSON.parse( sessionStorage.getItem('urlData') || '{}').placeCode  ||
								    JSON.parse( sessionStorage.getItem('ProjectConfigDetailData') || '{}').placeCode;
                    if(placeCode) {
                        this.placeCode = placeCode;
                    }
                    let urlData = JSON.parse( sessionStorage.getItem('urlData') || '{}');
                    await this.gotoLoginFn();
                    await this.getTerminalTypeByImei();
                    // this.getLocalPackageList();
                    // 先查询标签，后根据标签进行套餐列表的处理
                    this.getPackageTagList();
                    // this.getHotCountryList();
                    this.httpGetCoupons();
                    this.getCouonsTips();
                    this.getPackageUseDetail(); // 查询当前使用套餐

                    // 神策-设置公共属性
                    this.$sensors.registerPage({
                        imei: urlData.imei,
                        projectConfig: urlData.mvnoCode,
                        user_account: urlData.username,
                        operate_country: urlData.registerCountry || this.placeCode,
                    });

                    resolve();
                });
            },
            refresh(done) {
                this.setup().then(() => {
                    setTimeout(() => {
                        done();
                    }, 1000);
                })
            },
            // 获取当前设备类型
            async getTerminalTypeByImei(){
                let urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
                try {
                    let res = await this.$http.post({
                        url: '/bss/app/group/QueryGroupList',
                        data: {                        
                            imei: urlData?.imei,
                        }
                    })
                    if(res.data && res.data.length) {
                        this.terminalType = res.data[0].type;
                            let newData = {
                                ...urlData,
                                terminalType: res.data[0].type,
                            }
                            if(Object.keys(newData).length){
                                let urlDataString = JSON.stringify(newData);
                                sessionStorage.setItem('urlData',urlDataString);
                                localStorage.setItem('urlData',urlDataString);
                            }
                    };
                } catch (error) {
                    console.log(error);
                }

            },
            // 获取注册优惠券提示语
            getCouonsTips() {
                AppAndtips.getConfig('appTips-config.json').then(d => {
                    let lang = cookie.getCookie('langType') || 'en-US';
                    this.couponsTips = d.couponsTips[lang];
                    this.packageTips = d.packageTips[lang];
                    this.pgAndCoupTips = d.pgAndCoupTips[lang];
                    this.handlerShowTips();
                })
            },
            // 切换本地和全球
            packageTabsChange(name) {
                this.packageActiveKey = 0;
                this.countryActiveKey = 0;
                this.activeTab = name; // 设置当前激活的标签
                this.$refs.packageListRight.scrollTo({
                    top: 0
                });
            },
            // 切换大洲
            handlerContinent(continent) {
                this.activeContinent = continent.key; // 设置当前激活的大洲
                this.countryActiveKey = 0; // 重置国家激活状态
            },
            // 套餐列表左侧切换
            packageListGroupChange(index) {
                const target = document.querySelector(`.package-item-group[data-index="${index}"]`);
                let top = target.offsetTop;
                this.scrollFlag = true; // 设置滚动标志，避免重复触发
                this.$refs.packageListRight.scrollTo({
                    top: top,
                    behavior: 'smooth'
                });
                setTimeout(() => {
                    this.scrollFlag = false; // 重置滚动标志
                }, 800);
            },
            // 根元素滚动事件处理
            eleScrollHandler: throttle(function () {
                let element = document.documentElement || document.body; // 获取根元素
                let top = document.querySelector('.package-list-box')?.offsetTop || 0;
                let scrollTop = element.scrollTop;
                let isScrollBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 40;
                if(isScrollBottom || scrollTop + 35 >= top) {
                    this.isPackageRightScroll = true; // 设置套餐列表右侧滚动标志
                } else {
                    this.isPackageRightScroll = false; // 重置套餐列表右侧滚动标志
                }
            },200),
            // 监听套餐列表右侧滚动事件
            packageListRightScroll: throttle(function (key) {
                // let offsetHeight = document.querySelector('.package-list-box').offsetHeight;
                // document.documentElement.scrollTo({
                //     top: offsetHeight,
                // });

                if(this.scrollFlag || (!this.packageGroupList.length && !this.continentPackageList.length)) return; // 如果正在滚动，则不处理
                const anchors = document.querySelectorAll('.package-item-group[data-index]');
                let scrollTop = this.$refs.packageListRight.scrollTop;
                if(scrollTop <= 30) {
                    this[key] = 0; // 回到顶部时设置为第一个标签
                    return;
                } else if(scrollTop + this.$refs.packageListRight.clientHeight >= this.$refs.packageListRight.scrollHeight - 30) {
                    this[key] = anchors.length - 1; // 滚动到底部时设置为最后一个标签
                    return;
                }
                // 遍历所有的锚点，根据当前滚动位置设置激活的标签
                anchors.forEach(anchor => {
                    const groupTop = anchor.offsetTop;
                    const groupHeight = anchor.offsetHeight;
                    if (scrollTop >= groupTop - 20 && scrollTop < groupTop + groupHeight - 50) {
                        this[key] = anchor.dataset.index;
                        const target = document.querySelector(`.package-item-tag[data-index="${anchor.dataset.index}"]`);
                        if(!target) return;
                        let top = target.offsetTop;
                        this.$refs.packageListLeft.scrollTo({
                            top: top,
                            behavior: 'smooth'
                        });
                    }
                });
            },300),
            /*
            setCookies(data) {
                if(isEmptyObject(data)) return;
                cookie.clearAllCookie();
                data.accessToken && cookie.setCookie('access_token', data.accessToken);
                data.userId && cookie.setCookie('loginCustomerId', data.userId);
                data.mvnoCode && cookie.setCookie('mvnoCode', data.mvnoCode);
                data.orgId && cookie.setCookie('orgId', data.orgId);
                data.orgCode && cookie.setCookie('orgCode', data.orgCode);
                if(data.langType) {
                    cookie.setCookie('langType', data.langType)
                    this.$i18n.locale = data.langType
                }                
            },
            */
            goBack() {                                 
                window.dsBridge.call('closeDialog');              
            },
            goToMyFlow() {
                sessionStorage.removeItem('orderType');
                this.$router.push({
                    name: 'OrderList'
                });
            },
            goToCharge() {
                this.$router.push({
                    name: 'DiscountCodepager'
                });
            },
            goToCoupon()  {
                this.$router.push({
                    name: 'Coupons'
                });
            },
            // 判断是否展示套餐弹窗或者是优惠券弹窗
            handlerShowTips() {
                let CouponsTips = checkProjectConfig.setAppThat(this).checkValue("Module_CouponsTips",false);
                let PackageTips = checkProjectConfig.setAppThat(this).checkValue("Module_PackageTips",false);
                let DownLoadTips = checkProjectConfig.setAppThat(this).checkValue("Module_DownLoadTips",false);
                let isRegister = JSON.parse(localStorage.getItem('isRegister') || 'false');
                let isRegisterUrl = JSON.parse(localStorage.getItem('isRegisterUrl') || 'false');
                
                if((isRegister || isRegisterUrl) && location.pathname == "/Home") {

                    if(CouponsTips && PackageTips && !isRegisterUrl){
                        this.handlerShowPackageTips((...params) => {
                            this.handlerShowCouponsTips(...params);
                        });
                    } else {

                        if(CouponsTips) {
                            this.handlerShowCouponsTips();
                        };
                        if(PackageTips && !isRegisterUrl) {
                            this.handlerShowPackageTips();
                        }

                    }

                    if(this.isRegAndLogin && !CouponsTips && !PackageTips && DownLoadTips) {
                            this.$dialog.confirm({
                                title:this.$t('flowDetail.tip'),
                                message: this.$t('home.download_app_tips'),
                                confirmButtonText:this.$t('registerlogin.confirm'),
                                cancelButtonText:this.$t('registerlogin.cancel')
                            }).then(() => {
                                localStorage.setItem('isRegister',false);
                                window.open('https://mph5.ucloudlink.com/?uuid=4fb9b86a-3604-4cd8-80ac-9d3f0d419fa2&lang=zh-CN', '_blank');
                            }).catch(() => {
                                localStorage.setItem('isRegister',false);
                            })
                    }
                }
            },
            // 是否展示套餐tips弹窗
            handlerShowPackageTips(callback) {
                let urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
                let data = {
                        flag: 0,
                        queryNoUse: true,
                        goodsType: "ALL",
                        customerId: urlData['loginCustomerId'],
                        goodsExtendAttrs:["hideFlowSize"]
                }
                if(sessionStorage.getItem('Module_Bind_Group') === 'true'){
                    data = {
                    ...data,
                    imei:urlData?.imei
                    }
                }
                this.$http
                    .post({
                        url: "/bss/app/orderRelation/QueryUserOfferList",
                        data: {
                            ...data
                        }
                    })
                    .then(res => {
                        // 过滤掉配置不展示的套餐
                        let codeList = checkProjectConfig.setAppThat(this).checkValue("Test_Package_Codes",[]) || [];
                        let dataList = (res?.data?.dataList || []).filter(item => {
                            return item.attrMap.pkType != 'CSTC' && !codeList.includes(item.goodsCode);
                        });
                        // 判断是否存在赠送合约套餐
                        if(dataList && dataList.length) {
                            if(callback && typeof callback === 'function') {
                                callback(true, () => {
                                    Dialog.alert({
                                        message: this.packageTips,
                                        closeOnPopstate:false,
                                        confirmButtonText:this.$t('registerlogin.confirm'),
                                    })
                                    .then(() => {
                                        localStorage.setItem('isRegister',false);
                                    })                    
                                    .catch(() => {
                                        localStorage.setItem('isRegister',false);
                                    });
                                });
                            } else {
                                Dialog.alert({
                                    message: this.packageTips,
                                    closeOnPopstate:false,
                                    confirmButtonText:this.$t('registerlogin.confirm'),
                                })
                                .then(() => {
                                    localStorage.setItem('isRegister',false);
                                })                    
                                .catch(() => {
                                    localStorage.setItem('isRegister',false);
                                });
                            }
                        } else {
                            if(callback && typeof callback === 'function') {
                                callback(false);
                            }
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        if(callback && typeof callback === 'function') {
                            callback();
                        }
                    });
            },
            // 是否展示优惠券tips弹窗
            handlerShowCouponsTips(isShowPackage,callback) {
                // let CouponsTips = checkProjectConfig.setAppThat(this).checkValue("Module_CouponsTips",false);
                let urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
                // let isRegister = JSON.parse(localStorage.getItem('isRegister') || 'false');
                // if(CouponsTips && isRegister &&　location.pathname == "/Home") {
                    let sessionStorageUrlData = JSON.parse(sessionStorage.urlData) || {};
                    this.$http
                    .post({
                        url: "/bss/app/promotion/queryPromotionInst",
                        data: {
                            currentPage: 1,
                            perPageCount: 1000,
                            loginCustomerId: sessionStorageUrlData.loginCustomerId,
                            status:'AVAILABLE'
                        },
                    })
                    .then((res) => {
                        let data_CouponList = (res?.data?.dataList || []).map(item => {
                            return {
                                goodsList: item.goodsList,
                                promotionMode: item.promotionMode,
                                promotionCode: item.promotionCode,
                                fullCut: item.fullCut,
                                quota: item.quota,
                            }
                        })
                        sessionStorage.setItem('data-couponList', JSON.stringify(data_CouponList));

                        if(isShowPackage){
                            // 既有套餐也有优惠券
                            if(res.data && res.data.dataList && res.data.dataList.length > 0) {
                                Dialog.alert({
                                    message: this.pgAndCoupTips,
                                    closeOnPopstate:false,
                                    confirmButtonText:this.$t('registerlogin.confirm'),
                                    cancelButtonText:this.$t('registerlogin.cancel')
                                })
                                .then(() => {
                                    localStorage.setItem('isRegister',false);
                                    localStorage.setItem('isRegisterUrl',false);
                                })
                                .catch(() => {
                                    localStorage.setItem('isRegister',false);
                                    localStorage.setItem('isRegisterUrl',false);
                                });
                            } else {
                                if(callback && typeof callback === 'function') callback();
                                
                                localStorage.setItem('isRegister',false);
                                localStorage.setItem('isRegisterUrl',false); 
                            }
                        } else {
                            // 只有优惠券
                            if(res.data && res.data.dataList && res.data.dataList.length > 0) {
                                Dialog.confirm({
                                    message: this.couponsTips,
                                    closeOnPopstate:false,
                                    confirmButtonText:this.$t('registerlogin.confirm'),
                                    cancelButtonText:this.$t('registerlogin.cancel')
                                })
                                .then(() => {
                                    // 兼容之前的优惠券商品编码
                                    let goodsCode = this.$projectConfig[urlData.mvnoCode + "_Coupons_GoodsCode"] || this.$projectConfig["Module_Coupons_GoodsCode"];
                                    if(goodsCode){
                                        this.getPackageDetail(goodsCode)
                                        .then(res => {
                                            if(res.data && res.data.dataList && res.data.dataList.length > 0) {
                                                this.handlerGoodsDetails(res.data.dataList, () => {
                                                        this.$router.push(this.$setRouteQuery({
                                                            name: 'settlement',
                                                            query: {
                                                                goodsCode,
                                                                categoryCode: res.data.dataList[0].categoryCode,
                                                                goodsType: res.data.dataList[0].goodsType,
                                                                quantity: 1
                                                            }                 
                                                        },this));
                                                });
                                            } else {
                                                this.$router.push(this.$setRouteQuery({name: 'Coupons'},this));
                                            }
                                        }).catch(err => {
                                            console.log(err);
                                            this.$router.push(this.$setRouteQuery({name: 'Coupons'},this));
                                        });
                                    } else {
                                        this.$router.push(this.$setRouteQuery({name: 'Coupons'},this));
                                    }
    
                                    localStorage.setItem('isRegister',false);
                                    localStorage.setItem('isRegisterUrl',false);
                                })
                                .catch(() => {
                                    localStorage.setItem('isRegister',false);
                                    localStorage.setItem('isRegisterUrl',false);
                                });
                            } else {
                                    localStorage.setItem('isRegister',false);
                                    localStorage.setItem('isRegisterUrl',false); 
                            }
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$toast(err);
                    });
                // }
            },
            // 接口查询优惠券数量
            httpGetCoupons() {
                let sessionStorageUrlData = JSON.parse(sessionStorage.urlData) || {};
                if(!this.Module_Coupons_Page || !sessionStorageUrlData.loginCustomerId) return;
                this.$http
                    .post({
                        url: "/bss/app/promotion/queryPromotionInst",
                        data: {
                            currentPage: 1,
                            perPageCount: 1000,
                            loginCustomerId: sessionStorageUrlData.loginCustomerId,
                            status:'AVAILABLE'
                        },
                    })
                    .then((res) => {
                        if(res.data) {
                            this.couponList = res?.data?.dataList || [];
                            let data_CouponList = this.couponList.map(item => {
                                return {
                                    goodsList: item.goodsList,
                                    promotionMode: item.promotionMode,
                                    promotionCode: item.promotionCode,
                                    fullCut: item.fullCut,
                                    quota: item.quota,
                                }
                            })
                            sessionStorage.setItem('data-couponList', JSON.stringify(data_CouponList));
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$toast(err);
                    });
            },
            itemClickHandler(row) {
                this.$router.push({
                    name: 'PackageDetail',
                    query: {
                        goodsCode: row.goodsCode,
                        categoryCode: row.categoryCode,
                        goodsType: row.goodsType,
                        souce: '商城首页',
                    }                 
                });
            },
            toMoreLocalPackage() {
                this.goCountryPackageList({
                    iso2: this.placeCode,
                    countryName: this.countryName
                });
            },
            moreCountry() {
                this.$router.push({
                    name: 'RegionList'
                });    
            },
            _math() {
                const add = (arg1, arg2) => {
                    var r1, r2, m;
                    try {
                    r1 = arg1.toString().split(".")[1].length;
                    } catch (e) {
                    r1 = 0;
                    }
                    try {
                    r2 = arg2.toString().split(".")[1].length;
                    } catch (e) {
                    r2 = 0;
                    }
                    m = Math.pow(10, Math.max(r1, r2));
                    return (arg1 * m + arg2 * m) / m;
                };
                const sub = (arg1, arg2) => {
                    return add(arg1, -arg2);
                };
                return {
                    add,
                    sub
                };
            },
            // 查询当前使用套餐
            getPackageUseDetail() {
                if(!this.Module_MyFlow) return;
                let urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
                let data = {
                        flag: 0,
                        queryNoUse: true,
                        goodsType: "ALL",
                        customerId: urlData['loginCustomerId'],
                        goodsExtendAttrs:["hideFlowSize"]
                }
                if(sessionStorage.getItem('Module_Bind_Group') === 'true'){
                    data = {
                    ...data,
                    imei:urlData?.imei
                    }
                }
                this.$http
                    .post({
                        url: "/bss/app/orderRelation/QueryUserOfferList",
                        data: {
                            ...data
                        }
                    })
                    .then(res => {
                        if(res.data && res.data.dataList && res.data.dataList.length) {
                            // 过滤掉配置不展示的套餐
                            let codeList = checkProjectConfig.setAppThat(this).checkValue("Test_Package_Codes",[]);
                            let dataList = res.data.dataList;
                            if(codeList && codeList.length){
                                dataList = (res.data.dataList || []).filter(item => {
                                    return !codeList.includes(item.goodsCode);
                                })
                            }
                            let packageDetail = dataList.find( item => {
                                return item.inUse == '1'
                            })
                            if(!packageDetail){
                                packageDetail = dataList.find( item => {
                                    return item.status == 'VALID' && item.expiryTime
                                })
                            }

                            if(!packageDetail){
                                packageDetail = dataList.find( item => {
                                    return item.status == 'VALID'
                                })
                            }

                            if(!packageDetail){
                                packageDetail = dataList.find( item => {
                                    return item.status == 'NOT_ACTIVATED' || item.status == 'IN_USING'
                                })
                            }
                            //计算剩余时间、有效期
                            let  calcActiveTime = ({ expiryTime, activeDeadline, createTime, periodUnit, period }) =>{
                                period = period || 0;
                                //有效期
                                if (!expiryTime && !activeDeadline) {
                                    return {
                                        name: this.$t("order.validPeriod"),
                                        time: period + this.$t(`order.periodUnits.${periodUnit.toLowerCase()}`),
                                        notRed: !(periodUnit == "DAY" && period <= 3)
                                    };
                                }
                                //剩余时间
                                let remainingTime = (expiryTime ? expiryTime : activeDeadline * 24 * 3600 * 1000 + createTime) - Date.now();
                                let _calc = (time) => {
                                    if (time < 0) time = 0;
                                    //小时
                                    let hour = time / (3600 * 1000);
                                    if (hour < 1) return { time: Math.ceil(time / (60 * 1000)) + this.$t("order.periodUnits.minute") };
                                    if (hour < 24) return { time: Math.ceil(hour) + this.$t("order.periodUnits.hour") };
                                    //天
                                    let day = Math.ceil(time / (24 * 3600 * 1000));
                                    return {
                                        time: day + this.$t("order.periodUnits.day"),
                                        notRed: day > 3
                                    };
                                }
                                return Object.assign(_calc(remainingTime), { name: this.$t("order.remainingTime") });
                            }

                            //查询的销售品扩展属性列表
                            function goodsExtendAttrs(item,{extendValVos}) {
                                
                                if(extendValVos && extendValVos.length){
                                    extendValVos.forEach( _goodsExtendAttrsItem => {  
                                        // 获取 attrValueList 数组  
                                        const attrValueList = _goodsExtendAttrsItem.attrValueList;  
                                        
                                        // 判断attrValueList数组并获取值  
                                        const getValue= attrValueList && attrValueList[0];

                                        //a_hideFlowSize
                                        item['a_'+_goodsExtendAttrsItem.attrCode] = attrValueList;

                                        //a_getValue_hideFlowSize
                                        item['a_getValue_'+_goodsExtendAttrsItem.attrCode] = getValue;
                                    });
                                    
                                }
                            }
                            if(packageDetail){
                                    //优惠销售品
                                    if (packageDetail.goodsType == "DISC") {
                                        let da = packageDetail.accumulatedFlowList;
                                        da = (da && da[0]) || { totalFlow: "", accumulatedFlow: "" };
                                        let calculateFlow = this._math().sub(da.totalFlow, da.accumulatedFlow);
                                        calculateFlow = calculateFlow > 0 ? calculateFlow : 0;
                                        packageDetail.a_surplusFlow = { type: "DISC", flow: da.totalFlow, remainFlow: calculateFlow };
                                    }
                                    //流量包
                                    if (packageDetail.goodsType == "PKAG") packageDetail.a_surplusFlow = { type: "PKAG", flow: packageDetail.flowByte, remainFlow: packageDetail.surplusFlowbyte };

                                    packageDetail.a_activeTime = calcActiveTime(packageDetail);

                                    goodsExtendAttrs(packageDetail,packageDetail);

                                    
                                    if(!packageDetail.effectiveTime && !packageDetail.expiryTime){
                                        packageDetail.isUseActive = false
                                    } else {
                                        packageDetail.isUseActive = true
                                    }

                                    this.packageUseDetail = packageDetail;

                                    setTimeout(() => {
                                        this.$refs?.NewHome?.setUseStyle();
                                    }, 300);
                            } else {
                                this.packageUseDetail = null;
                            }
                        } else {
                            this.packageUseDetail = null;
                        }
                        this.isShowNoData = true;
                    })
                    .catch((err) => {
                        console.log(err);
                        this.isShowNoData = true;
                    });
            },
            // 查询套餐标签
            getPackageTagList() {
                let urlData = JSON.parse(sessionStorage.getItem('urlData') || '{}');
                if(!urlData.loginCustomerId || this.isRegAndLogin) return;
                this.$http.post({
                    url: 'bss/app/noauth/QueryOfferTag',
                    data: {
                        ignoreOfferTagFlag: 1,
                        offerTagFlag:0,
                        offerTagMethod:1,
                    }
                })
                .then((res) => {
                    this.packageGroupList = [];
                    let tagList = [];
                    this.isShowPackageList = false;
                    this.count = 0; // 重置计数器
                    if(res.data && res.data.length){
                        res.data.forEach(element => {
                            // 目前先只查询本地流量套餐
                            let tagValueList = element.tagValueList || [];
                            if(element.tagKey === 'LOCAL') {
                                // 根据返回的标签调用接口查询本地流量套餐
                                if(!tagValueList || !tagValueList.length) {
                                    this.getLocalPackageList(); // 如果没有标签数据，则直接查询本地流量套餐
                                }

                                tagValueList.forEach(tag => {
                                    tagList.push(tag.tagValueName);
                                    this.getLocalPackageList(tag.extendValueMap || {}, tag.tagValueName);
                                });
                            } else if(element.tagKey === 'ROAMING') {
                                // this.getHotRegion(); // 查询热门大洲
                                this.getContinentPackageList(); // 查询全部的漫游套餐
                            }
                        })
                        this.allTagList = res.data;
                        this.activeTab = res.data[0].tagKey;
                    } else {
                        this.getLocalPackageList(); // 如果没有标签数据，则直接查询本地流量套餐
                    }
                    this.packageTagList = tagList;
                    this.packageGroupList = tagList.map(tag => ({
                        tagValueName: tag,
                        packageList: []
                    }));
                })
                .catch((err) => {
                    console.log(err);
                });
            },
            // 本地流量
            getLocalPackageList(extendValueMap,tagValueName,) {
                let channelType = this.$APP_CONFIG.request.channelType,                 
                    //terminalType = this.$APP_CONFIG.request.terminalType,
                    mcc = this.placeCode;
                this.$http.post({
                    url: '/bss/app/noauth/QueryOfferList',
                    data: {                        
                        channelType,
                        queryLimitFlag: true,
                        queryPromotionFlag: true,
                        mcc,
                        sortFlag: 1,
                        showFlowFlag:1,
                        areaFlag: extendValueMap ?  'LOCAL' : '', // 保留原来没有extendValueMap的逻辑，查询本地流量套餐
                        params: {
                            queryVipDayFlag: true
                        },
                        buyTerminalType:this.terminalType,
                        extendValueMap, // 根据扩展属性查询对应的标签套餐
                        perPageCount: 1000,
                        goodsExtendAttrs:["detailRemark"] // detailRemark 获取扩展属性
                    }
                }).then(res => {
                    let tmpList = res.data.dataList || [];
                    /*
                        本地流量按照后端顺序显示
                    */                    
                    //tmpList = tmpList.length > 0 ? this.sortFun(this.initLocalPackageData(tmpList)) : [];
                    //this.doPromotionList(tmpList);
                    //this.local_package_list = [...this.has_promotion_list, ...this.no_promotion_list].slice(0, 4);
                    
                    // 按照后端返回顺序显示前4个数据
                    tmpList = tmpList.length > 0 ? this.initLocalPackageData(tmpList) : [];                                        
                    // this.local_package_list = tmpList.slice(0, 4).map(item => ({...item, attrValueList: [] }));  
                    // this.local_package_list.forEach(item => {
                    //     if(item.extendValVos && item.extendValVos.length){
                    //         item.extendValVos.forEach(val => {
                    //             item.attrValueList = [...item.attrValueList, ...val.attrValueList];
                    //         });
                    //     }
                    // });

                    // 按套餐标签进行分类
                    tmpList = tmpList.map(item => ({...item, attrValueList: [] }));  
                    tmpList.forEach(item => {
                        if(item.extendValVos && item.extendValVos.length){
                            item.extendValVos.forEach(val => {
                                item.attrValueList = [...item.attrValueList, ...val.attrValueList];
                            });
                        }
                    });

                    this.count += 1; // 增加计数器

                    if(this.packageTagList && this.packageTagList.length){
                        let index = this.packageGroupList.findIndex(packageGroup => packageGroup.tagValueName === tagValueName);
                        if(tmpList && tmpList.length) { 
                            this.isShowPackageList = true;

                            this.packageGroupList.splice(index, 1, {
                                tagValueName: tagValueName,
                                packageList: tmpList
                            });
                        } else {
                            let index = this.packageGroupList.findIndex(packageGroup => packageGroup.tagValueName === tagValueName);
                            this.packageGroupList.splice(index, 1);
                        }    
                    } else {
                        this.isShowPackageList = true; // 如果没有标签套餐数据，则直接显示本地流量套餐列表
                        (tmpList && tmpList.length) ?  (this.packageGroupList = [
                            {
                                packageList: tmpList || [],
                            }
                        ]) : this.packageGroupList = [];
                    }
                    if(this.count >= this.packageTagList.length && this.packageTagList?.length){ // 如果所有标签查询完成
                        this.isShowPackageList = true; // 所有标签查询完成后显示套餐列表
                        this.count = 0; // 重置计数器
                        if(!this.packageGroupList?.length && !this.count) {
                            // this.getLocalPackageList(); // 如果没有标签套餐数据，则重新查询本地所有流量套餐
                        }
                    }
                }).catch(err => {
                    this.$toast(err);
                });
            },
            // 查询热门大洲套餐
            async getContinentPackageList(extendValueMap = {}) {
                let channelType = this.$APP_CONFIG.request.channelType;
                await this.getCoverList();
                this.$http.post({
                    url: '/bss/app/noauth/QueryOfferList',
                    data: {             
                        areaFlag: 'ROAMING',           
                        channelType,
                        queryLimitFlag: true,
                        queryPromotionFlag: true,
                        sortFlag: 1,
                        showFlowFlag:1,
                        perPageCount: 2000,  
                        params: {
                            queryVipDayFlag: true
                        },
                        extendValueMap, // 根据扩展属性查询对应的标签套餐
                        buyTerminalType:this.terminalType,
                        goodsExtendAttrs:["detailRemark"] // detailRemark 获取扩展属性
                    }
                }).then(res => {
                    let tmpList = res.data.dataList || [];
                    tmpList = tmpList.length > 0 ? this.initLocalPackageData(tmpList) : [];;

                    // 按套餐标签进行分类
                    tmpList = tmpList.map(item => ({...item, attrValueList: [] }));  
                    tmpList.forEach(item => {
                        if(item.extendValVos && item.extendValVos.length){
                            item.extendValVos.forEach(val => {
                                item.attrValueList = [...item.attrValueList, ...val.attrValueList];
                            });
                        }
                    });

                    // let countryList = this.continentList.find(item => {
                    //     return item.key === this.activeContinent;
                    // })?.countryList || [];
                    let countryList = this.countryInfoList.filter((item) => {
                        return item.iso2 !== 'ALL'
                    });
                    let arr = countryList.map(item => {
                        let packageList = tmpList.filter(packageItem => {
                            if(packageItem.iso2List && packageItem.iso2List.length) {
                                return packageItem.iso2List.includes(item.iso2) || packageItem.iso2List.includes('ALL');
                            } else {
                                return false;
                            }
                        })
                        return {
                            ...item,
                            name:item.countryName,
                            packageList,
                        }
                    })

                    this.continentPackageList = arr.filter(item => item.packageList && item.packageList.length > 0);
                    
                }).catch(err => {
                    console.log(err);
                    this.$toast(err);
                });
            },
            // 查询区域套餐
            getRegionPackageList(extendValueMap = {},tagValueName) {
                let channelType = this.$APP_CONFIG.request.channelType;
                this.$http.post({
                    url: '/bss/app/noauth/QueryOfferList',
                    data: {                        
                        channelType,
                        queryLimitFlag: true,
                        queryPromotionFlag: true,
                        sortFlag: 1,
                        showFlowFlag:1,
                        params: {
                            queryVipDayFlag: true
                        },
                        extendValueMap, // 根据扩展属性查询对应的标签套餐
                        buyTerminalType:this.terminalType,
                        perPageCount: 1000,
                        goodsExtendAttrs:["detailRemark"] // detailRemark 获取扩展属性
                    }
                }).then(res => {
                    let tmpList = res.data.dataList || [];
                    
                    // 按照后端返回顺序显示前4个数据
                    tmpList = tmpList.length > 0 ? this.initLocalPackageData(tmpList) : [];

                    // 按套餐标签进行分类
                    tmpList = tmpList.map(item => ({...item, attrValueList: [] }));  
                    tmpList.forEach(item => {
                        if(item.extendValVos && item.extendValVos.length){
                            item.extendValVos.forEach(val => {
                                item.attrValueList = [...item.attrValueList, ...val.attrValueList];
                            });
                        }
                    });

                    if(this.packageTagList && this.packageTagList.length){
                        let index = this.continentPackageList.findIndex(packageGroup => packageGroup.name === tagValueName);
                        if(tmpList && tmpList.length) { 
                            this.continentPackageList.splice(index, 1, {
                                name: tagValueName,
                                packageList: tmpList
                            });
                        } else {
                            let index = this.continentPackageList.findIndex(packageGroup => packageGroup.name === tagValueName);
                            this.continentPackageList.splice(index, 1);
                        }    
                    }
                }).catch(err => {
                    this.$toast(err);
                });
            },
            // 查询热门大洲
            async getHotRegion() {
                let typeCode ;
                let typeCode_mvnoCode = JSON.parse(sessionStorage.getItem('urlData') || '{}').mvnoCode;

                if(typeCode_mvnoCode){
                    await this.getCoverList();
                    typeCode =  `HOTREGION_${typeCode_mvnoCode.toUpperCase()}`;
                    this.$http.post({
                        url: '/bss/app/noauth/dictionary/QueryDictionaryValueListInfo',
                        data: {                      
                            type: typeCode, 
                        }
                    }).then(res => {
                        // Africa - UN60 、Oceania - UN29、 Asia - UN50、European - UN52、SouthAmerica - UN57、 NorthAmerica - UN57
                        let continent = {
                            'UN60': 'Africa',
                            'UN29': 'Oceania',
                            'UN50': 'Asia',
                            'UN52': 'European',
                        };

                        this.continentList = (res.data || []).map(item => {
                            let countryList = this.countryInfoList.filter(country => {
                                if(continent[item.key]){
                                    return country.continent === continent[item.key];
                                } else {
                                    return country.continent === 'SouthAmerica' || country.continent === 'NorthAmerica';
                                }
                            })
                            return {
                                key: item.key,
                                value:item.value,
                                countryList
                            }
                        })

                        // this.activeContinent = this.continentList[0]?.key; // 默认选中第一个大洲
                        
                    }).catch(() => {
                    });
                }
            },
            // 优先优惠(promotionFlag为true,再按价格升序)
            doPromotionList(list) {
                list.forEach(item => {
                    if(item.promotionFlag) {
                        this.has_promotion_list.push(item);
                    } else {
                        this.no_promotion_list.push(item);
                    }
                })
            },
            initLocalPackageData(list) {                
                let newList = [];

                for(let i = 0;i < list.length;i++) {                    
                    let item  = list[i];
                    item.goodsPrice = +item.goodsPrice + "";

                    // 页面只显示DISC、PKAG
                    if(item.goodsType != 'DISC' && item.goodsType != 'PKAG') {
                        continue;
                    }
                    // 过滤黑名单
                    if(item.mccFlag && item.mccFlag == 'BLACK') {
                        continue;
                    }
                    // 过滤掉用户自定义
                    if(item.attrMap.effType == 'USER_DEFINED') {
                        continue;
                    }
                    // 过滤掉DIY
                    if((item.goodsType == 'DISC' && item.categoryCode == 'GDIY') || (item.goodsType == 'PKAG' && item.attrMap.pkType == 'DIY')) {
                        continue;
                    }
                    // 过滤掉CZME
                    if(item.categoryCode && item.categoryCode == 'CZME') {
                        continue;
                    }
                    // 过滤DSDS
                    /*
                    if(item.terminalType == 'DSDS') {
                        continue;
                    }
                    */
                    
                    item.item_bg = unlimited_bg;
                    if(item.goodsType == 'DISC') {
                        item.item_bg = unlimited_bg;
                    } else if(item.goodsType == 'PKAG') {
                        item.item_bg = normal_bg;
                    }
                    item.showCountDown = false;
                    // 增加立省多少，有活动优惠时
                    if(item.discountPrice && item.promotionActivityCode && this.Module_CountDownAndSave){
                        this.doPriceStyle(item, item.goodsPrice - item.discountPrice, 'savingPrice');
                        // 调用活动接口，查询具体活动，如果是两个取当前的活动截止时间作为倒计时
                        this.getPromotion(item);
                    }
                    
                    if(item.deductionInfo?.autoRenewFirstPrice && item.promotionActivityCode && this.Module_CountDownAndSave){
                        this.doPriceStyle(item, item.goodsPrice - item.deductionInfo.autoRenewFirstPrice, 'savingPrice');
                        // 调用活动接口，查询具体活动，如果是两个取当前的活动截止时间作为倒计时
                        this.getPromotion(item);
                    }
                    
                    // 处理价格
                    item.listPriceShow = false;
                    item.vipPriceShow = false;
                    if(item.payAgreeFlag == "1" && item.deductionInfo != null && item.deductionInfo.autoRenewActCode != null) {
                        // vip会员日并且最低价是discountPrice
                        if(item.vipAct && item.vipAct === '1' && this.minPriceIsDiscountPrice(item)) {
                            this.doPriceStyle(item, item.goodsPrice, 'goodsPriceText');
                            this.doPriceStyle(item, item.discountPrice, 'vipPrice');
                            item.vipPriceShow = true;
                        } else {
                            let autoRenewFirstPrice = item.deductionInfo.autoRenewFirstPrice ? item.deductionInfo.autoRenewFirstPrice : 0.0;
                            if(autoRenewFirstPrice > 0 && autoRenewFirstPrice < item.goodsPrice) {
                                this.doPriceStyle(item, this.getMinPrice(item), 'goodsPriceText');
                                item.listPriceShow = true;
                                this.doPriceStyle(item, item.goodsPrice, 'listPrice');
                            } else {
                                this.doPriceStyle(item, this.getMinPrice(item), 'goodsPriceText');
                            }
                        }
                    } else {
                        // vip 会员日
                        if(item.vipAct && item.vipAct === '1') {
                            this.doPriceStyle(item, item.goodsPrice, 'goodsPriceText');
                            this.doPriceStyle(item, item.discountPrice, 'vipPrice');
                            item.vipPriceShow = true;
                        } else {
                            this.doPriceStyle(item, item.discountPrice !== null ? item.discountPrice : item.goodsPrice, 'goodsPriceText');
                            if(item.discountPrice != null) {
                                this.doPriceStyle(item, item.goodsPrice, 'listPrice');
                                item.listPriceShow = true;
                            }
                        }
                    }
                    //生成角标
                    this.genSaleIcon(item);

                    // multi region packages
                    if(item.iso2List && (item.iso2List.length > 1 || item.iso2List[0] == 'ALL')) {                 
                        item.multiRegionFlag = true;
                    } else if (item.goodsType == 'DISC') {
                        if (['BYTC', 'SWBY', 'BTTC', 'LXCX'].includes(item.categoryCode)) {
                            item.unlimitedFlag = true;
                            this.doUnlimitedPackages(item);
                        }
                    } else if(item.goodsType == 'PKAG') {
                        if(item.attrMap.pkType != 'DIY') {
                            item.normalFlag = true;
                            this.doNormalPackages(item)
                        }
                    }

                    newList.push(item);
                }
                
                return newList;
            },
            genSaleIcon(item) {
                /*
                 * sale icon
                 * */
                item.saleTextShow = false;
                item.saleIconShow = false;
                item.saleLeftTipShow = false;
                let _w = 'auto';
                if(isAndroid()) {
                    /*
                    if(Math.floor(window.devicePixelRatio) == 1) {
                        _w = `${100/3}%`
                    } else if(Math.floor(window.devicePixelRatio) == 2 || Math.floor(window.devicePixelRatio) == 3) {
                        _w = `${(100*2)/3}%`;
                    }
                    */
                } else {
                    if(Math.floor(window.devicePixelRatio) == 1) {
                        _w = `${100/3}%`
                    } else if(Math.floor(window.devicePixelRatio) == 2) {
                        _w = `${(100*2)/3}%`;
                    }
                }
                item.saleIconStyle = {
                    width: _w
                };
                let saleImageUrl = '';
                let tipText = '';
                // 获取图标
                if(item.cornerMark != null && Object.values(item.cornerMark).length > 0 && Object.values(item.cornerMark).some(val => val != '')) {
                    if(item.payAgreeFlag == "1" && item.deductionInfo != null && item.deductionInfo.autoRenewActCode != null) {
                        saleImageUrl = item.cornerMark[item.deductionInfo.autoRenewActCode];
                    } else {
                        saleImageUrl = item.cornerMark[item.promotionActivityCode];
                    }
                } else if(item.iconInfos && item.iconInfos.length > 0) {
                    saleImageUrl = item.iconInfos.find(icon => {
                        if(icon.attrValue.startsWith('http://') || icon.attrValue.startsWith('https://')) {
                            return true;
                        }
                    })?.attrValue;

                    tipText = item.iconInfos.find(icon => {
                        if(!icon.attrValue.startsWith('http://') && !icon.attrValue.startsWith('https://')) {
                            return true;
                        }
                    })?.attrValue;
                }
                // 判断图标是否为空
                if(saleImageUrl) {
                    item.saleImageUrl = saleImageUrl;
                    item.saleIconShow = true;
                }
                // 判断左侧文字提示
                if(tipText) {
                    item.saleLeftTipText = tipText;
                    item.saleLeftTipShow = true;
                }
                let img = new Image(),iconStyle = {};
                img.addEventListener('load', () => {
                    if(img.width >= this.boxItemWidth) {
                        iconStyle = {width: '100%'};
                    } else {
                        iconStyle = {width: 'auto'};
                    }
                    this.$set(item,'iconStyle',iconStyle);
                },false)

                if(item.saleImageUrl){
                    img.src = item.saleImageUrl;    
                }
                
            },
            doNormalPackages(item) {
                this.genName(item);
                this.doNormalPackagesCycle(item);
            },
            //处理普通包有效期
            doNormalPackagesCycle(item) {
                let expireToday = item.goodsType != 'DISC' && item.attrMap.expType == 'CURRENT_DAY',
                    expireThisMonth = item.goodsType != 'DISC' && item.attrMap.expType == 'CURRENT_MONTH',
                    effectiveImmediately = item.goodsType == 'DISC' && item.attrMap.effType == 'IMMEDIATELY',
                    effectiveMarrow = item.goodsType == 'DISC' && item.attrMap.effType == 'MARROW',
                    effectiveNextMonth = item.goodsType == 'DISC' && item.attrMap.effType == 'NEXT_MONTH';

                if(expireToday || expireThisMonth) {
                    item.period = expireToday ? `${this.$t('packages.day_invalid')}` : `${this.$t('packages.month_invalid')}`
                } else {
                    if(item.period) {
                        let singleUnit = this.$t(`packages.periodUnit.${item.periodUnit.toLowerCase()}`),
                            multipleUnit = this.$t(`packages.periodUnits.${item.periodUnit.toLowerCase()}`);
                        item.period = item.period > 1 ? `${item.period} ${multipleUnit}` : `${item.period} ${singleUnit}`;
                        if(effectiveImmediately) {
                            item.period = item.period > 1 ? `${item.period} ${multipleUnit}(${this.$t('packages.immediate_valid')})` : `${item.period} ${singleUnit}(${this.$t('packages.immediate_valid')})`;
                        } else if(effectiveMarrow) {
                            item.period = item.period > 1 ? `${item.period} ${multipleUnit}(${this.$t('packages.tomorrow_day_valid')})` : `${item.period} ${singleUnit}(${this.$t('packages.tomorrow_day_valid')})`;
                        } else if(effectiveNextMonth) {
                            item.period = item.period > 1 ? `${item.period} ${multipleUnit}(${this.$t('packages.tomorrow_month_valid')})` : `${item.period} ${singleUnit}(${this.$t('packages.tomorrow_month_valid')})`;
                        }
                    }
                }
            },
            doUnlimitedPackages(item) {
                this.genName(item);
                // 0为按小时取，1为按天取，2为按月取，3为按年取，12为动态月也是按月取同2
                item.high_speed_text = this.$t('packages.high_speed_text');
                let billInfo = item.billingInfos;
                if(billInfo && billInfo.length > 0) {
                    if(billInfo[0].periodUnit === 0) {
                        if(item.period == billInfo[0].period && item.periodUnit == 'HOUR') {
                            item.high_speed_text = this.$t('packages.high_speed_text');
                        } else {
                            if(billInfo[0].period > 1) {
                                item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitsSimp.hour')
                            } else {
                                item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.hour')
                            }
                        }

                    } else if(billInfo[0].periodUnit === 1) {
                        if(item.period == billInfo[0].period && item.periodUnit == 'DAY') {
                            item.high_speed_text = this.$t('packages.high_speed_text');
                        } else {
                            if(billInfo[0].period > 1) {
                                item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitSimp.day')
                            } else {
                                item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.day')
                            }
                        }

                    } else if(billInfo[0].periodUnit === 2 || billInfo[0].periodUnit === 12) {
                        if(item.period == billInfo[0].period && item.periodUnit == 'MONTH') {
                            item.high_speed_text = this.$t('packages.high_speed_text');
                        } else {
                            if(billInfo[0].period > 1) {
                                item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitsSimp.month')
                            } else {
                                item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.month')
                            }
                        }
                    } else if(billInfo[0].periodUnit === 3) {
                        if(item.period == billInfo[0].period && item.periodUnit == 'YEAR') {
                            item.high_speed_text = this.$t('packages.high_speed_text');
                        } else {
                            if(billInfo[0].period > 1) {
                                item.high_speed_text = item.high_speed_text + '/' + billInfo[0].period + this.$t('packages.periodUnitsSimp.year')
                            } else {
                                item.high_speed_text = item.high_speed_text + '/' + this.$t('packages.periodUnitSimp.year')
                            }
                        }
                    }
                }

                if(item.categoryCode == 'BTTC' || (item.categoryCode == 'LXCX' && item.periodUnit == 'DAY')) {
                    item.goodsNameStr = this.$t('packages.unlimited_good_name.day');

                } else if (item.categoryCode == 'BYTC' || item.categoryCode == 'SWBY' || (item.categoryCode == 'LXCX' && item.periodUnit == 'MONTH')) {
                    if(item.period && item.period == 12) {
                        item.goodsNameStr = this.$t('packages.unlimited_good_name.year');
                    } else {
                        if(item.attrmap && item.attrmap.period && item.attrmap.period == 12) {
                            item.goodsNameStr = this.$t('packages.unlimited_good_name.year');
                        } else {
                            item.goodsNameStr = this.$t('packages.unlimited_good_name.month');
                        }
                    }
                }
            },
            genName(item) {
                let flow = (item.billingInfos && item.billingInfos.length > 0) ? item.billingInfos[0].flow : item.flowByte;
                if(flow > 0) {
                    if(flow > 1000) {
                        flow = flow/1024;
                        // 判断是不是整数
                        if(Math.floor(flow) === flow) {
                            item.goodsName_H5_tag = `${flow}GB`;
                        } else {
                            item.goodsName_H5_tag = `${keepTwodecimalFixed(flow)}GB`;
                        }
                    } else {
                        item.goodsName_H5_tag = `${flow}MB`;
                    }
                } else {
                    item.goodsName_H5_tag = `0MB`;
                }
            },
            getMinPrice(item) {
                let prices = [];

                if(item.deductionInfo.autoRenewFirstPrice) {
                    prices.push(item.deductionInfo.autoRenewFirstPrice);
                }
                if(item.deductionInfo.autoRenewPrice) {
                    prices.push(item.deductionInfo.autoRenewPrice);
                }
                if(item.discountPrice) {
                    prices.push(item.discountPrice);
                }
                if(item.goodsPrice) {
                    prices.push(item.goodsPrice);
                }

                return Math.min(...prices);
            },
            doPriceStyle(item, price, key) {
                //price = keepTwodecimalFull(price/100);
                //item[key] = `${item.currencyType} ${price}`;
                item[key] = this.globalPriceFormat(item.currencyType, price);                
            },
            minPriceIsDiscountPrice(item) {
                let autoRenewFirstPrice = item.deductionInfo.autoRenewFirstPrice ? item.deductionInfo.autoRenewFirstPrice : 0.0;
                let autoRenewPrice = item.deductionInfo.autoRenewPrice ? item.deductionInfo.autoRenewPrice : 0.0;
                let discountPrice = item.discountPrice ? item.discountPrice : 0.0;
                if(autoRenewPrice > discountPrice && autoRenewFirstPrice > discountPrice) {
                    return true;
                }
                return false;
            },
            sortFun(list) {
                for(let i=0;i<list.length;i++) {
                    for(let j = 0;j < list.length - 1 - i;j++) {
                        if(list[j].goodsPrice - list[j+1].goodsPrice > 0) {
                            let tmpObj = list[j];
                            list[j] = list[j+1];
                            list[j+1] = tmpObj;
                        }
                    }
                }
                return list;
            },
            getCoverList() {
                return this.getCoverListMixin().then(res => {
                    this.countryInfoList = res.data;
                    this.getCountryName();  
                }).catch(err => {
                    this.$toast(err)
                });
            },
            getCountryName() {
                let code = this.placeCode;
                this.countryName = this.countryInfoList.find(item => item.iso2 == code.toUpperCase()).countryName;
            },
            // 热门目的地
            async getHotCountryList() {
                // 默认国家不需要
                let countryCodeList;
                // let countryCodeList = checkProjectConfig.setAppThat(this).checkValue("DEFAULT_HOT_COUNTRY",DEFAULT_HOT_COUNTRY);
                
                let hotKey = 'ALL';
                let typeCode ;
                let typeCode_mvnoCode = JSON.parse(sessionStorage.getItem('urlData') || '{}').mvnoCode;

                if(typeCode_mvnoCode){
                    typeCode =  `HOTCOUNTRY_${typeCode_mvnoCode.toUpperCase()}`;   
                    await this.getCoverList();
                    this.$http.post({
                        url: '/bss/app/noauth/dictionary/QueryDictionaryValueListInfo',
                        data: {
                            key: hotKey,                        
                            type: typeCode,
                        }
                    }).then(res => {                    
                        if(res.data && res.data.length) {
                            countryCodeList = res.data[0].value.split(',').slice(0, 7);
                            this.countryList = this.initHotCountryData(countryCodeList);
                        }                    
                        
                    }).catch(() => {
                        //this.$toast(err)    
                        //栏目隐藏
                        this.countryList = [];
                    });
                }
            },
            initHotCountryData(list) {
                let newList = [];
                list.forEach(value => {
                    this.countryInfoList.forEach(item => {                        
                        if(value == item.iso2) {                            
                            let ua = isAndroid() ? 'Android' : 'IOS';
                            let iconImg = require(`../../assets/imgs/iconsForCountry/${ua}/${value.toUpperCase()}@3x.png`);
                            newList.push({
                                iso2: value,
                                countryName: item.countryName,
                                icon: iconImg
                            })
                        }
                    })
                })                
                return newList;
            },
            goCountryPackageList(item) {
                // 神策-点击国家
                this.$sensors.track('WebChooseACountry', {
                    country_iso2: item.iso2,
                    country_name: item.countryName,
                });


                this.$router.push({
                    name: 'Packages',
                    query: {
                        mcc: item.iso2,
                        countryName: item.countryName
                    }
                });
            },
            /**優惠券弹窗点击确定跳转到订单页面 */
            handlerGoodsDetails(list,success){
                let that = this,flow;
                let tempData = list[0]
                //按照老业务展示流量大小
                // tempData.showFlow = this.doFlowByteText(tempData) + ' ' + high_speed_text;
                // tempData.showPeriod = this.getValidityPeriod(tempData);
                //元转分 方法统一使用该项目处理方案
                tempData.showPrice = that.doPriceStyle(tempData, tempData.goodsPrice);
                tempData.showUserDetail = tempData.attrMap.pkDesc;
                tempData.showIsInfinite = tempData.attrMap.infiniFlag;
                this.mccLength = tempData.iso2List.length;
                tempData.periodStr = (tempData.billingInfos && tempData.billingInfos[0]) ?  this.moOrDay(tempData.billingInfos[0]) : '' ;

                // //复用流量商城原始方法获取地区
                // this.showAreaList = tempData.mccList.join(SymbolMap[cookie.getCookie('langType')]||', ');

                //连续畅销
                tempData.firstPrice = '';
                tempData.oringPrice = '';
                
                //营销活动划线价格
                if(tempData.discountPrice){

                    tempData.showPrice = that.doPriceStyle(tempData, tempData.discountPrice);
                    //tempData.goodsPrice 此处单位和货币展示不处理，由模板处理
                    tempData.oringPrice = tempData.goodsPrice; 
                }

                let isLxcx  = false ; //默认选择
                let selectPackage = tempData.goodsId;
                
                try{
                    let data_package = {
                        selectPackage:selectPackage,
                        isLxcx:isLxcx,
                        data:{}
                    }
                    if(tempData.goodsId){
                        data_package.data[selectPackage] = JSON.stringify(tempData);   
                    }
                        
                    sessionStorage.setItem('data_info',JSON.stringify(data_package));
                }catch(e){
                    let data_package = '{"selectPackage":"'+
                                        selectPackage+
                                        '","isLxcx":'+
                                        isLxcx+
                                        ',"data":['+
                                        JSON.stringify(this.normalPkgData)+
                                        ']}';
                    sessionStorage.setItem('data_info',data_package);
                    console.log('数据异常,请仔细检查')
                }
                sessionStorage.setItem('data_coverage',tempData.iso2List);
                success &&　success();
            },
            //新老版本使用方法不同，保留genHighSeepText方法 
            moOrDay(data){
                var str = "";
                if(data.periodUnit == 1){
                if(data.period>1){
                    str = data.period+this.$t('packages.periodUnits.day');
                }else{
                    str = this.$t('packages.periodUnit.day');
                }

                }else if(data.periodUnit == 2 || data.periodUnit == 12){
                    if(data.period>1){
                        str = data.period+this.$t('packages.periodUnitsSimp.month');
                    }else{
                        str = this.$t('packages.periodUnitSimp.month');
                    }
                }else if(data.periodUnit == 0){
                    if(data.period>1){
                        str = data.period+this.$t('packages.periodUnits.hour');
                    }else{
                        str = this.$t('packages.periodUnit.hour');
                    }
                }else if(data.periodUnit == 3){
                    if(data.period>1){
                        str = data.period+this.$t('packages.periodUnits.year');
                    }else{
                        str = this.$t('packages.periodUnit.year');
                    }
                }else{
                    str = '';
                }
                return str;
            
            },
            // 查询套餐活动
            getPromotion(item){
                let that = this;
                let actDetailList = { //营销活动
                    goodsCode: item.goodsCode,
                    params:{
                        "queryVipDayFlag":false,
                        "supportExclusive":true
                    }
                }
                that.$http.post(this.$api.getPromotion, actDetailList)
                .then(res => {
                        if(res.data && res.data?.length > 1) {
                            let promotion = res.data.find(act => {
                                return act.code === item.promotionActivityCode
                            });
                            let countDown = promotion.endTime - new Date().getTime();
                            this.packageGroupList.forEach(group => {
                                group.packageList.forEach(pkg =>{ 
                                    if(pkg.goodsId === item.goodsId) {
                                        if(countDown > 0) {
                                            pkg.countDown = countDown;
                                            pkg.showCountDown = true;
                                        } else {
                                            pkg.showCountDown = false;
                                        }
                                    }
                                });
                            });
                            this.continentPackageList.forEach(group => {
                                group.packageList.forEach(pkg =>{ 
                                    if(pkg.goodsId === item.goodsId) {
                                        if(countDown > 0) {
                                            pkg.countDown = countDown;
                                            pkg.showCountDown = true;
                                        } else {
                                            pkg.showCountDown = false;
                                        }
                                    }
                                });
                            });
                        } else {
                        }
                    }).catch(err => {
                        console.log(err);
                    });
            },
            // 倒计时结束
            handlerCountDownEnd(item) {
                item.showCountDown = false;
            },

            /***** */
        }
    }
</script>

<style lang="less" scoped>
    @import 'css/index.less';
</style>